module.exports = __webpack_public_path__ + "img/rwm.b2f09e63.jpg";